import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { SITE_MASTER_COLORS } from 'components/SiteMaster/SiteMaster.styles';

export const StNearBySiteLocationSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  maxWidth: '1366px',
  margin: '0 auto',
  backgroundColor: theme.palette.backgroundColorType3.main,
  padding: theme.spacing(3, 4),
  gap: theme.spacing(3),

  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(10, 12),
    gap: theme.spacing(5),
  },
}));

export const StNearBySiteLocationTitle = styled('h2')(({ theme }) => ({
  margin: 0,
  fontFamily: `${theme.palette.secondaryFontFamilyType}, 'Noto Serif', serif`,
  fontSize: theme.typography.pxToRem(24),
  fontWeight: 400,
  lineHeight: '33px',
  color: SITE_MASTER_COLORS.teal,

  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.pxToRem(32),
    lineHeight: '44px',
  },
}));

export const StNearBySiteLocationGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(3),
  width: '100%',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
}));

export const StNearBySiteLocationCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.common.white,
  height: '100%',
}));

export const StNearBySiteLocationCardHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  width: '100%',
}));

export const StNearBySiteLocationSiteName = styled('h3')(({ theme }) => ({
  margin: 0,
  fontFamily: theme.palette.primaryFontFamilyType,
  fontSize: theme.typography.pxToRem(20),
  fontWeight: 700,
  lineHeight: '27px',
  color: SITE_MASTER_COLORS.textDark,
}));

export const StNearBySiteLocationLocationRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontFamily: theme.palette.primaryFontFamilyType,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 400,
  lineHeight: '19px',
  color: SITE_MASTER_COLORS.textSecondary,
}));

export const StNearBySiteLocationTagList = styled('ul')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  gap: theme.spacing(1),
  listStyle: 'none',
  margin: 0,
  padding: 0,
  width: '100%',
}));

export const StNearBySiteLocationTag = styled('li')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  padding: theme.spacing(0.75, 1.5),
  borderRadius: theme.spacing(2.5),
  backgroundColor: SITE_MASTER_COLORS.chipNeutralBg,
  fontFamily: theme.palette.primaryFontFamilyType,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 500,
  lineHeight: '19px',
  color: SITE_MASTER_COLORS.textPrimary,
}));

export const StNearBySiteLocationButtonWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: theme.spacing(1, 0),
  width: '100%',
}));
